import { createFileRoute } from "@tanstack/react-router";

import { OrganizationId } from "@goose/schema/Salesforce";

export const Route = createFileRoute(
  "/_authenticated/admin/organizations/$organizationId",
)({
  params: {
    parse: ({ organizationId }) => {
      return {
        organizationId: OrganizationId.parse(organizationId),
      };
    },
  },
});
